import { Box, CircularProgress } from "@mui/material";
import { COLOR_LESS_BLACK } from "../../data/colors/Colors";

interface p {
  minHeight?: string;
  color?: string;
}
export function LoadingView(p: p) {
  return (
    <Box
      sx={{
        minHeight: p.minHeight ?? "80vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <CircularProgress sx={{ color: p.color ?? COLOR_LESS_BLACK }} />
    </Box>
  );
}
